import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ILoggerNoiseSpectrum } from '@app/api/interfaces/chart-data/logger-noise-spectrum';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface IFpLoggerNoiseSpectrumState {
  currentTab: FpLoggerNoiseTabs.SignalSpectrum;
  date: string | null;
  popupMainData: ILdLogger | null;
  data: ILoggerNoiseSpectrum[] | null;
  loading: boolean;
  isChartFullscreenActive: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpLoggerNoiseSpectrumState: IFpLoggerNoiseSpectrumState = {
  currentTab: FpLoggerNoiseTabs.SignalSpectrum,
  date: null,
  popupMainData: null,
  data: null,
  loading: false,
  isChartFullscreenActive: false,
  error: null,
};
